import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import _ from 'lodash';
import slugify from 'slugify';

import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreHorizIcon from 'material-ui/svg-icons/navigation/more-horiz';
import IconEdit from 'material-ui/svg-icons/content/create';
import IconDelete from 'material-ui/svg-icons/action/delete';
import Download from 'material-ui/svg-icons/content/font-download';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import classes from './Project.scss';

import { DetailField } from '../../../components/DetailField/DetailField';
import ContactCard from '../../../components/ContactCard/ContactCard';
import FileTable from '../../../components/FileTable/FileTable';
import { renderTabCount } from '../../../helpers/renderTabCount';
import ActivityTableEmbed from '../../../components/ActivityTableEmbed/ActivityTableEmbed';
import TaskList from '../../../components/TaskList';
import { getLocalizedProjectStrings } from '../../../models/Project';
import FormFileUpload from '../../../components/FormFileUpload/FormFileUpload';
import ProjectTableEmbed from '../../../components/ProjectTable/ProjectTable';
import { simplApiUrlPure } from '../../../api/simplApi';

class Project extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      alert: null,
      selectedIndex: 0,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.project !== this.props.params.project) {
      this.props.setProject(nextProps.params.project);
      // project changed, switch back to first tab
      this.setState({ selectedIndex: 0 });
    }
  }

  componentWillMount() {
    this.props.setProject(this.props.params.project);
  }

  componentDidMount() {
    this.props.fetchProject(this.props.params.project);
  }

  handleSelect = index => {
    this.setState({ selectedIndex: index });
  };

  handleAlertClose = () => {
    this.setState({
      alert: null,
    });
  };

  renderHeader = () => (
    <header>
      <ul className="breadcrumbs">
        <li>
          <Link to="/project" activeClassName={classes.activeRoute}>
            {this.props.projectCount} Projekte
          </Link>
        </li>
        <li>
          {this.props.project.name}
          {this.props.project.deleted_at === null ? (
            ''
          ) : (
            <span className="deletedTag">gelöscht</span>
          )}
        </li>
      </ul>
      <IconMenu
        iconButtonElement={
          <IconButton>
            <MoreHorizIcon />
          </IconButton>
        }
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'right', vertical: 'top' }}
        className="overflow-right"
      >
        <MenuItem
          primaryText="Projekt bearbeiten"
          leftIcon={<IconEdit className="svg-icon-primary" />}
          key="editProject"
          className="menu-primary"
          onClick={() => {
            this.props.setProjectForm(this.props.project.id);
          }}
        />

        <MenuItem
          primaryText="Projekt löschen"
          leftIcon={
            <IconDelete className="svg-icon-primary svg-icon-warning" />
          }
          key="delProject"
          className="menu-primary"
          onClick={() => {
            this.setState({
              alert: (
                <Dialog
                  actions={[
                    <FlatButton
                      label="Abbrechen"
                      primary
                      onTouchTap={this.handleAlertClose}
                    />,
                    <FlatButton
                      label="Löschen"
                      primary
                      onTouchTap={() => {
                        this.handleAlertClose();
                        this.props.deleteProject(this.props.project.id); // this.props.push('/project');
                        this.props.router.push('/project');
                      }}
                    />,
                  ]}
                  modal={false}
                  open
                  onRequestClose={this.handleAlertClose}
                >
                  Projekt wirklich löschen?
                </Dialog>
              ),
            });
          }}
        />
        <MenuItem
          primaryText="Projekt als PDF exportieren"
          leftIcon={<Download className="svg-icon" />}
          key="downloadProject"
          className="menu-primary"
          onClick={() => {
            const id =
              typeof this.props.project.simpl_account === 'string'
                ? this.props.project.simpl_account
                : this.props.project.simpl_account.id;
            window.open(
              simplApiUrlPure(
                `export/pdf/project/${id}/${this.props.project.id}/${this.props.project.linkHash}`,
              ),
              '_blank',
            );
          }}
        />
      </IconMenu>
      {this.state.alert}
    </header>
  );
  renderField = (label, content, key) => {
    if (
      typeof content !== 'undefined' &&
      content !== null &&
      (content.length ||
        (typeof content.value !== 'undefined' && content.value.length))
    ) {
      const actualContent =
        typeof content === 'string' ? content : content.value;
      const effectiveKey = key || slugify(label);
      return (
        <div className="row overview" key={effectiveKey}>
          <div className="col-xs-12 col-sm-3">
            <label dangerouslySetInnerHTML={{ __html: label }} />
          </div>
          <div className="col-xs-12 col-sm-9">
            <span dangerouslySetInnerHTML={{ __html: actualContent }} />
          </div>
        </div>
      );
    }
    return <div />;
  };
  renderContacts = () => {
    const contacts = [];
    _.forOwn(this.props.persons, value => {
      // create new object that will be handled by griddle
      const email = _.find(value.contact_details, ['type', 'email']);
      const phone = _.find(value.contact_details, ['type', 'tel']);
      const position = _.find(value.meta, ['key', 'position']);
      contacts.push(
        <ContactCard
          name={value.name}
          number={phone ? phone.value : null}
          email={email ? email.value : null}
          position={position ? position.value : null}
          avatar={value.avatar}
          key={`contactcard_${value.id}`}
        />,
      );
    });
    if (contacts.length === 0) {
      return <div />;
    }
    return (
      <section>
        <h2>Kontakte</h2>
        <div className="row">{contacts}</div>
      </section>
    );
  };
  renderContactDetails = () => {
    const details = [];
    this.props.project.contact_details.forEach(contactDetail => {
      details.push(
        this.renderField(
          contactDetail.type,
          contactDetail.value,
          `contact_detail_${contactDetail.id}`,
        ),
      );
    });
    return details;
  };
  renderOverview = () => {
    const project = this.props.project;
    const extraInfo = getLocalizedProjectStrings(project);
    let label = 'Projektstart';
    let end = '';
    if (typeof extraInfo.endDate !== 'undefined') {
      end = ` bis<br />${extraInfo.endDate}`;
      label = 'Projektzeitraum';
    }
    return (
      <div>
        <section>
          <h2>Allgemein</h2>
          <DetailField label="Projektname" content={project.name} />
          <DetailField label="Projektnummer" content={project.project_number} />
          <DetailField label="Projektstatus" content={extraInfo.status} />
          {this.renderLinks()}
          <DetailField label={label} content={`${extraInfo.startDate}${end}`} />
          <DetailField
            label="Bemerkungen"
            content={project.description}
            className="notes"
          />
        </section>
      </div>
    );
  };
  renderLinks = () => {
    const output = [];
    if (this.props.projectParent && this.props.projectParent.id) {
      output.push(
        <div className="row overview" key="project_link">
          <div className="col-xs-12 col-sm-3">
            <label>Hauptprojekt</label>
          </div>
          <div className="col-xs-12 col-sm-9">
            <Link
              key="projectlink"
              to={`/project/${this.props.projectParent.id}`}
            >
              {this.props.projectParent.name}
            </Link>
          </div>
        </div>,
      );
    }
    if (this.props.company && this.props.company.id) {
      output.push(
        <div className="row overview" key="company_link">
          <div className="col-xs-12 col-sm-3">
            <label>Unternehmen</label>
          </div>
          <div className="col-xs-12 col-sm-9">
            <Link key="companylink" to={`/company/${this.props.company.id}`}>
              {this.props.company.name}
            </Link>
          </div>
        </div>,
      );
    }
    if (this.props.leader && this.props.leader.id) {
      output.push(
        <div className="row overview" key="projectleader_link">
          <div className="col-xs-12 col-sm-3">
            <label>Projektleiter</label>
          </div>
          <div className="col-xs-12 col-sm-9">
            <ContactCard
              name={this.props.leader.name}
              avatar={this.props.leader.avatar}
              key={`contactcard_${this.props.leader.id}`}
              type="staff"
              displayType="small"
              id={this.props.leader.id}
            />
          </div>
        </div>,
      );
    }
    return output;
  };
  render() {
    if (!this.props.project || Object.keys(this.props.project).length === 0) {
      // no data loaded yet
      return <div />;
    }
    Tabs.setUseDefaultStyles(false);
    return (
      <div
        className={
          this.props.project.deleted_at === null
            ? 'wrapper details-view'
            : 'wrapper details-view deletedModel'
        }
      >
        {this.renderHeader()}
        <Tabs
          onSelect={this.handleSelect}
          selectedIndex={this.state.selectedIndex}
          className="content"
        >
          <TabList activeTabClassName="active">
            <Tab>
              <span>Details</span>
            </Tab>
            <Tab>
              <span>Aktivitäten {renderTabCount(this.props.activities)}</span>
            </Tab>
            <Tab>
              <span>Aufgaben {renderTabCount(this.props.tasks)}</span>
            </Tab>
            <Tab>
              <span>Dateien {renderTabCount(this.props.files)}</span>
            </Tab>
            <Tab>
              <span>Unterprojekte {renderTabCount(this.props.projects)}</span>
            </Tab>
          </TabList>

          <TabPanel>{this.renderOverview()}</TabPanel>
          <TabPanel>
            <ActivityTableEmbed
              activities={this.props.activities}
              staffs={this.props.staffs}
              compact
            />
          </TabPanel>
          <TabPanel>
            <section>
              <h2>{renderTabCount(this.props.tasks, true)} Aufgaben</h2>
            </section>
            <TaskList
              tasks={this.props.tasks}
              showTaskForm
              taskableType="project"
              taskableId={this.props.project.id}
              showFutureDates
            />
          </TabPanel>
          <TabPanel>
            <section>
              <h2>{renderTabCount(this.props.files, true)} Dateien</h2>
            </section>
            <section className="no-padding">
              <FileTable
                files={this.props.files}
                deleteFile={this.props.deleteFile}
              />
            </section>
          </TabPanel>
          <TabPanel>
            <section>
              <h2>{renderTabCount(this.props.projects, true)} Projekte</h2>
            </section>
            <section className="no-padding">
              <ProjectTableEmbed
                projects={this.props.projects}
                staffs={this.props.staffs}
              />
            </section>
          </TabPanel>
        </Tabs>

        <FormFileUpload
          attachableId={this.props.project.id}
          attachableType="App\Project"
          files={[]}
          onUpdate={() => {
            this.props.fetchProject(this.props.project.id);
          }}
          invisible
          disabled={this.props.formOpen}
        />
      </div>
    );
  }
}
Project.propTypes = {
  fetchProject: PropTypes.func.isRequired,
  setProject: PropTypes.func.isRequired,
  setProjectForm: PropTypes.func.isRequired,
  deleteProject: PropTypes.func.isRequired,
  deleteFile: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  project: PropTypes.object,
  projectCount: PropTypes.number,
  activities: PropTypes.array.isRequired,
  files: PropTypes.array,
  tasks: PropTypes.array,
  staffs: PropTypes.array,
  persons: PropTypes.array,
  leader: PropTypes.object,
  company: PropTypes.object,
  projectParent: PropTypes.object,
  params: PropTypes.object,
  router: PropTypes.object,
  formOpen: PropTypes.bool,
};
export default withRouter(Project);



// WEBPACK FOOTER //
// ./src/routes/ProjectDetail/components/Project.js